import {useInfiniteQuery, UseInfiniteQueryResult} from '@tanstack/react-query';
import {useHelpContext} from '@/app/(main)/routes/help/context/HelpContext';
import {getFaqList} from '@/api/help/faq';
import {Faq} from '@/api/help/faq/type';
import {getNextPageNo} from '@/utils/help';

export type UseGetFaqListInfinityResult = UseInfiniteQueryResult<
  {faqList: Faq[]; count: number},
  Error
>;

interface UseGetFaqListInfinityProps {
  category: string;
}

export const useGetFaqListInfinity = ({
  category,
}: UseGetFaqListInfinityProps): UseGetFaqListInfinityResult => {
  const {isMobile} = useHelpContext();

  return useInfiniteQuery({
    queryKey: ['help', 'faq', 'infinity', category],
    queryFn: ({pageParam}) => getFaqList({page: pageParam, category}),
    select: ({pages}) => ({
      faqList: pages.map(({data}) => data.faqList).flat(),
      count: pages[pages.length - 1].data.faqCount,
    }),
    initialPageParam: 1,
    getNextPageParam: (lastPage) =>
      getNextPageNo(lastPage.data?.pageNo, lastPage.data?.faqCount),
    enabled: isMobile,
  });
};
